import { RootState } from 'src/store';

export const getLeaderboards = (state: RootState) =>
  state?.performanceDashboard?.leaderboards;

const getRankingsObj = (state: RootState) =>
  state?.performanceDashboard?.rankings;

export const getRankings = (state: RootState) => getRankingsObj(state)?.data;

export const getRankingColumns = (state: RootState) =>
  getRankingsObj(state)?.table?.columns || [];

export const getRankingsTableInfo = (state: RootState) =>
  getRankingsObj(state)?.table;

export const getIndividualRankings = (state: RootState) =>
  getRankingsObj(state)?.individual;

export const getRankingsMeta = (state: RootState) =>
  getRankingsObj(state)?.meta;

export const getRankingsListViewOptions = (state: RootState) =>
  getRankingsObj(state)?.listViewOptions;

const getKeyMetrics = (state: RootState) =>
  state?.performanceDashboard?.keyMetrics;

export const getKeyMetricsList = (state: RootState) =>
  getKeyMetrics(state)?.cards || [];

export const getKeyMetricsGroups = (state: RootState) =>
  getKeyMetrics(state)?.goal_groups?.data || [];

export const getKeyMetricsPaginationInfo = (state: RootState) =>
  getKeyMetrics(state)?.next || {};

export const getStatus = (state: RootState, key) =>
  state?.performanceDashboard?.status?.[key];

const getKeyMetricsDetailsObj = (state: RootState) =>
  state?.performanceDashboard?.keyMetricsDetails;

export const getKeyMetricsDetails = (state: RootState) =>
  getKeyMetricsDetailsObj(state)?.data || {};

export const getKeyMetricsTeamBreakdown = (state: RootState) =>
  getKeyMetricsDetailsObj(state)?.teamBreakdown || {
    data: [],
    columns: [],
  };

export const getKeyMetricsBreakdownGraph = (state: RootState) =>
  getKeyMetricsDetailsObj(state)?.breakdownGraph;

export const getKeyMetricsTrendGraph = (state: RootState) =>
  getKeyMetricsDetailsObj(state)?.trendGraph;

export const getPerformanceSnapshot = (state: RootState) =>
  state?.performanceDashboard?.snapshot || [];
